import { render, staticRenderFns } from "./LockedUsers.vue?vue&type=template&id=1f9c3238&"
import script from "./LockedUsers.vue?vue&type=script&lang=js&"
export * from "./LockedUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports